import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import type { NodeSocketKindMap } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const torqueToolConsumerNodeSpec: NodeSpec<NodeCfg<'torqueToolConsumer'>> = {
    nodeCategory: 'connection',
    nodeSubCategory: 'Torque Tool',
    requiredSockets: (_node, inputs, outputs) => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: [
                    ...inputs,
                    ...outputs,
                ] as (keyof NodeSocketKindMap['torqueToolConsumer']['inputs'] | keyof NodeSocketKindMap['torqueToolConsumer']['outputs'])[],
            },
        ],
    }),
    kindLabel: 'Torque Tool Consumer',
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.TorqueTool ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
    }),
    cfg: () => ({ id: getUID(), kind: 'torqueToolConsumer', width: 220, controlValues: { connectionId: '' } }),
    inputs: () => ({}),
    outputs: () => ({
        badTighteningEvent: { socket: 'event', label: 'Bad Tightening Event' },
        goodTighteningEvent: { socket: 'event', label: 'Good Tightening Event' },
        torque: { socket: 'number', label: 'Torque' },
        angle: { socket: 'number', label: 'Angle' },
    }),
    validator: node => node.controlValues.connectionId ? true : { connectionId: 'Connection id is required' },
};
